import '../vendor/TimedPopup.js';

$(function () {
  const $newsletterPopUp = $('#newsletter-popup');
  if ($newsletterPopUp.length <= 0) return false;

  window.dAgency.showNewsletterPopUp = () => {
    $newsletterPopUp.addClass('timed-popup__visible');
    document.querySelector('html').style.overflow = 'hidden';
  };

  window.dAgency.hideNewsletterPopUp = () => {
    $newsletterPopUp.removeClass('timed-popup__visible');
    document.querySelector('html').style.overflow = '';
  };

  $('.newsletter-popup-opener').on('click', function () {
    window.dAgency.showNewsletterPopUp();
  });

  $('.newsletter-popup-closer').on('click', function () {
    window.dAgency.hideNewsletterPopUp();
  });
});
